module.exports = __webpack_public_path__ + "static/media/riskpic2@3x.0494b83f.png";